import React from 'react';
import logo from './logo.png';

export default function RejectedPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', system-ui, sans-serif", position: "relative", overflow: "hidden", padding: "40px 24px" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;900&family=DM+Serif+Display:ital@0;1&display=swap" rel="stylesheet" />

      <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)", backgroundSize: "48px 48px", pointerEvents: "none" }} />
      <div style={{ position: "absolute", top: "20%", left: "50%", transform: "translateX(-50%)", width: 600, height: 400, background: "radial-gradient(ellipse, rgba(220,38,38,0.06) 0%, transparent 70%)", pointerEvents: "none" }} />

      <div style={{ width: "100%", maxWidth: 460, position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 40, justifyContent: "center" }}>
          <img src={logo} style={{ width: 36, height: 36 }} alt="Binos" />
          <span style={{ fontWeight: 900, fontSize: 22, color: "#fff", letterSpacing: "-0.5px" }}>Binos</span>
        </div>

        <div style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 20, padding: "40px 32px" }}>
          <h1 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 30, fontWeight: 400, color: "#fff", margin: "0 0 12px", letterSpacing: "-0.5px" }}>Not the right fit — yet.</h1>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.45)", lineHeight: 1.7, margin: "0 0 28px" }}>
            We're being selective about our early cohort. This doesn't mean never — reach out at any time.
          </p>

          <a
            href="mailto:anas@binos-ai.com?subject=Binos%20Access%20Request"
            style={{ display: "block", width: "100%", padding: "13px", background: "#dc2626", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 800, color: "#fff", cursor: "pointer", textAlign: "center", textDecoration: "none", boxSizing: "border-box", fontFamily: "inherit" }}
          >
            Contact Us
          </a>
        </div>

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <a href="/" style={{ fontSize: 12, color: "rgba(255,255,255,0.2)", textDecoration: "none", fontWeight: 500 }}
            onMouseEnter={e => e.target.style.color = "rgba(255,255,255,0.5)"}
            onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.2)"}>
            ← Back to home
          </a>
        </div>
      </div>
    </div>
  );
}
